/* eslint-disable react/prop-types */
import {
  Button,
  IconButton,
  InputBase,
  Paper,
  Typography,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {
  AddCircleOutlineOutlined,
  FileCopyOutlined,
  RemoveCircleOutlineOutlined,
} from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { getErrors, times } from "./utils";
import { Validator } from "./validator2";

const useStyles = makeStyles((theme) => ({
  dropdowns: {
    minWidth: 180,
    maxWidth: 180,
    height: 36,
    backgroundColor: "#f1f3f4",
    display: "flex",
    gap: "16px",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: 16,
    paddingRight: 16,
    borderRadius: theme.shape.borderRadius,
  },
  actions: { display: "flex", gap: "16px", alignItems: "center" },
  root: {
    display: "flex",
    gap: "16px",
    alignItems: "center",
  },
}));
// const ValidatorInstance = Validator.instance();
const TimeSlot = (props) => {
  const classes = useStyles();
  const {
    index,
    slot,
    dayIndex,
    slotsCount,
    onAdd,
    onDelete,
    onCopy,
    // control,
    day,
    disabled,
    isFirst,
  } = props;
  const theme = useTheme();

  const dayName = day.name;
  const { control, trigger } = useFormContext();

  const { isValid, errors } = Validator.instance();

  const hasError = () => {
    let has = false;
    for (let i = 0; i < slotsCount; ++i)
      if (
        getErrors(errors, dayName, i, "start") ||
        getErrors(errors, dayName, i, "end")
      ) {
        has = true;
      }

    return has;
  };

  return (
    <div className={classes.root}>
      <div className={classes.dropdowns}>
        <Controller
          name={`${dayName}.slots[${index}].start`}
          control={control}
          defaultValue={slot.start}
          render={(props) => (
            <Autocomplete
              id="start"
              disabled={disabled}
              value={props.value}
              options={times}
              getOptionLabel={(option) => option}
              disableClearable
              clearOnBlur
              selectOnFocus
              PaperComponent={({ children }) => (
                <Paper style={{ minWidth: 100 }}>{children}</Paper>
              )}
              renderInput={(params) => (
                <InputBase
                  disabled={disabled}
                  inputRef={params.InputProps.ref}
                  inputProps={params.inputProps}
                  style={{
                    fontSize: "14px",
                    backgroundColor: getErrors(errors, dayName, index, "start")
                      ? theme.palette.error.light
                      : "",
                  }}
                />
              )}
              onChange={(e, val) => {
                props.onChange(val);
                // trigger([
                //   `${dayName}.slots[${index}].start`,
                //   `${dayName}.slots[${index}].end`,
                // ]);
              }}
              error={getErrors(errors, dayName, index, "start")}
            />
          )}
        />

        <Typography variant="body1" style={{ fontSize: "14px" }}>
          to
        </Typography>

        <Controller
          name={`${dayName}.slots[${index}].end`}
          control={control}
          defaultValue={slot.end}
          render={(props) => (
            <Autocomplete
              id="end"
              value={props.value}
              disabled={disabled}
              options={times}
              getOptionLabel={(option) => option}
              disableClearable
              clearOnBlur
              selectOnFocus
              PaperComponent={({ children }) => (
                <Paper style={{ minWidth: 100 }}>{children}</Paper>
              )}
              renderInput={(params) => (
                <InputBase
                  disabled={disabled}
                  inputRef={params.InputProps.ref}
                  inputProps={params.inputProps}
                  style={{
                    fontSize: "14px",
                    backgroundColor: getErrors(errors, dayName, index, "end")
                      ? theme.palette.error.light
                      : "",
                  }}
                />
              )}
              onChange={(e, val) => {
                props.onChange(val);
                // trigger([
                //   `${dayName}.slots[${index}].start`,
                //   `${dayName}.slots[${index}].end`,
                // ]);
              }}
              error={getErrors(errors, dayName, index, "end")}
            />
          )}
        />
      </div>
      <div className={classes.actions}>
        <IconButton
          disabled={disabled}
          size="small"
          style={{
            visibility: index + 1 == slotsCount ? "visible" : "hidden",
          }}
          onClick={() => {
            if (onAdd) onAdd();
          }}
        >
          <AddCircleOutlineOutlined fontSize="small" />
        </IconButton>

        {isFirst ? (
          index != 0 && (
            <IconButton
              disabled={disabled}
              size="small"
              style={{
                visibility: index != 0 ? "visible" : "hidden",
              }}
              onClick={() => {
                if (onDelete) onDelete(slot, index);
              }}
            >
              <RemoveCircleOutlineOutlined fontSize="small" />
            </IconButton>
          )
        ) : (
          <IconButton
            disabled={disabled}
            size="small"
            style={{
              visibility: index != 0 ? "visible" : "hidden",
            }}
            onClick={() => {
              if (onDelete) onDelete(slot, index);
            }}
          >
            <RemoveCircleOutlineOutlined fontSize="small" />
          </IconButton>
        )}

        <Button
          color="primary"
          size="small"
          disabled={disabled || (isFirst && index == 0 && hasError())}
          style={{
            visibility: isFirst && index == 0 ? "visible" : "hidden",
            padding: 4,
          }}
          onClick={() => {
            if (onCopy) onCopy(day);
          }}
        >
          <FileCopyOutlined fontSize="small" color="inherit" />
          <Typography
            color="inherit"
            style={{ marginLeft: 8, fontSize: 14, textTransform: "none" }}
          >
            Copy time{slotsCount > 1 ? "s" : ""} to all
          </Typography>
        </Button>
      </div>
    </div>
  );
};

export default TimeSlot;
